import React from 'react';
import Agenda from 'conversional-big-calendar/lib/Agenda';
import { Empty } from 'antd';
import { F } from '@/utils/intl';

export const WEEK_AGENDA_VIEW = 'weekAgenda';

function WeekAgendaView({ date, localizer, ...props }) {
  const weekStart = localizer.startOf(date, 'week');
  return <Agenda {...props} localizer={{
    ...localizer,
    messages: {...localizer.messages,
      date: <F id={"common.date.date"} defaultMessage={"Date"}/>,
      time: <F id={"common.date.time"} defaultMessage={"Time"}/>,
      event: <F id={"pages.leads.appointment"} defaultMessage={"Event"}/>,
      noEventsInRange: <Empty/>}
  }} length={6} date={weekStart} />;
}

// show 7 days — full week range
WeekAgendaView.range = (date, { localizer }) => {
  const start = localizer.startOf(date, 'week'); // usually Monday (depends on locale)
  const end = localizer.endOf(date, 'week');     // Sunday
  const range = [];

  let current = start;
  while (localizer.lte(current, end, 'day')) {
    range.push(current);
    current = localizer.add(current, 1, 'day');
  }

  return range;
};

WeekAgendaView.navigate = (date, action, { localizer }) => {};

// title shows week range (e.g. "Oct 7 – Oct 13, 2025")
WeekAgendaView.title = (date, { localizer }) => {
  const start = localizer.startOf(date, 'week');
  const end = localizer.endOf(date, 'week');
  return `${localizer.format(start, 'MMM d')} – ${localizer.format(end, 'MMM d, yyyy')}`;
};

export default WeekAgendaView;
